import { render, staticRenderFns } from "./PasswordResetModal.vue?vue&type=template&id=526d6c7c&scoped=true&"
import script from "./PasswordResetModal.vue?vue&type=script&lang=js&"
export * from "./PasswordResetModal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetModal.vue?vue&type=style&index=0&id=526d6c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526d6c7c",
  null
  
)

component.options.__file = "PasswordResetModal.vue"
export default component.exports